/* XGuidance brand FX — logo particles + footer gold dust + footer reveal */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfg = document.querySelector('[data-xgbf]') || { dataset: {} };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var COLS = ['255,241,184', '21,242,252', '0,255,136', '255,255,255', '187,48,254'];
  var LOGO = ['255,255,255', '255,255,255', '123,31,214', '255,215,90', '0,200,120'];
  var SMALL = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  // one pre-rendered glow per colour, instead of a new radial gradient per particle per frame
  var sprites = {};
  function sprite(c) {
    if (sprites[c]) return sprites[c];
    var s = document.createElement('canvas'); s.width = s.height = 32;
    var g = s.getContext('2d'), gr = g.createRadialGradient(16, 16, 0, 16, 16, 16);
    gr.addColorStop(0, 'rgba(' + c + ',0.9)'); gr.addColorStop(1, 'rgba(' + c + ',0)');
    g.fillStyle = gr; g.fillRect(0, 0, 32, 32);
    return (sprites[c] = s);
  }
  // start ambient particles only after the page has loaded (keeps first paint / TBT clean)
  function afterLoad(fn) {
    var go = function () { setTimeout(fn, SMALL ? 1500 : 300); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  }

  function particles(host, opts) {
    var cv = document.createElement('canvas'); cv.className = opts.cls; cv.setAttribute('aria-hidden', 'true');
    host.insertBefore(cv, host.firstChild);
    var ctx = cv.getContext('2d'), W = 0, H = 0, ps = [], running = false, last = 0, vis = true;
    var dpr = Math.min(1.5, window.devicePixelRatio || 1);
    function size() { var r = cv.getBoundingClientRect(); if (Math.abs(r.width - W) < 1 && Math.abs(r.height - H) < 1 && cv.width > 1) return; W = r.width; H = r.height; cv.width = Math.max(1, W * dpr); cv.height = Math.max(1, H * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    function spawn() {
      var gold = opts.gold;
      ps.push({ x: Math.random() * W, y: gold ? H + 4 : H * (0.25 + Math.random() * 0.6), vx: (Math.random() - 0.5) * (gold ? 0.25 : 0.5), vy: -(0.15 + Math.random() * (gold ? 0.5 : 0.7)),
        l: 0, m: 90 + Math.random() * 120, s: gold ? 1 + Math.random() * 2.2 : 1 + Math.random() * 2, c: gold ? (Math.random() < 0.8 ? COLS[0] : COLS[3]) : LOGO[(Math.random() * LOGO.length) | 0] });
    }
    function draw(ts) {
      if (!running) return;
      requestAnimationFrame(draw);
      if (ts - last < 32) return; last = ts;
      ctx.clearRect(0, 0, W, H);
      if (ps.length < opts.max && Math.random() < opts.rate) spawn();
      ctx.globalCompositeOperation = opts.gold ? 'lighter' : 'source-over';
      for (var i = ps.length - 1; i >= 0; i--) {
        var p = ps[i]; p.l++; p.x += p.vx; p.y += p.vy;
        var a = Math.sin(Math.PI * p.l / p.m);
        if (p.l >= p.m) { ps.splice(i, 1); continue; }
        ctx.globalAlpha = a; ctx.drawImage(sprite(p.c), p.x - p.s * 4, p.y - p.s * 4, p.s * 8, p.s * 8); ctx.globalAlpha = 1;
        if (!opts.gold && a > 0.7 && p.s > 1.8) { ctx.strokeStyle = 'rgba(255,255,255,' + (a * 0.6).toFixed(2) + ')'; ctx.lineWidth = 0.6; ctx.beginPath(); ctx.moveTo(p.x - 5, p.y); ctx.lineTo(p.x + 5, p.y); ctx.moveTo(p.x, p.y - 5); ctx.lineTo(p.x, p.y + 5); ctx.stroke(); }
      }
      ctx.globalCompositeOperation = 'source-over';
    }
    var ready = false;
    var start = function () { if (!ready || running || RM || !vis || document.hidden) return; running = true; last = 0; requestAnimationFrame(draw); };
    afterLoad(function () { ready = true; start(); });
    var stop = function () { running = false; };
    size(); window.addEventListener('resize', size);
    if ('ResizeObserver' in window) new ResizeObserver(size).observe(cv);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; vis ? start() : stop(); }).observe(host);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  }

  function boot() {
    var root = document.documentElement;
    if (root.classList.contains('xgbf-logo') && cfg.dataset.logoParticles !== 'false' && !RM) {
      $$('a.header__heading-link, a.header__heading-logo').forEach(function (a) {
        if (a.__xgbf || !a.querySelector('img')) return; a.__xgbf = 1;
        particles(a, { cls: 'xgbf-canvas', max: SMALL ? 12 : 26, rate: 0.35, gold: false });
      });
    }
    if (root.classList.contains('xgbf-foot')) {
      $$('.footer').forEach(function (f) {
        if (f.__xgbf) return; f.__xgbf = 1; f.classList.add('xgbf-js');
        $$('.footer-block__list', f).forEach(function (l) { $$('li', l).forEach(function (li, i) { li.style.setProperty('--xi', i); }); });
        if ('IntersectionObserver' in window && !RM) {
          var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { f.classList.add('is-in'); io.disconnect(); } }, { threshold: 0.08 });
          io.observe(f);
        } else f.classList.add('is-in');
        var top = f.querySelector('.footer__content-top');
        if (top && cfg.dataset.footerParticles !== 'false' && !RM) particles(top, { cls: 'xgbf-fcanvas', max: SMALL ? 20 : 40, rate: 0.5, gold: true });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
